// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zpse","comment":"styles_comment__bayp3"};